import { FC, useEffect, useState } from "react";
import { CarDataType } from "data/types";
import TabFilters from "./TabFilters";
import FleetCard from "components/FleetCard/FleetCard";
import { useNavigate } from "react-router-dom";
import { useData } from "data/data-provider";
import { CarListingModal } from "models/vehicleModal";

export interface SectionGridFilterCardProps {
  className?: string;
  data?: CarDataType[];
}

const SectionGridFilterCard: FC<SectionGridFilterCardProps> = ({
  className = "",
  data,
}) => {
  const navigate = useNavigate();
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  const { availableFleet, pickupLocation, setSelectedCar } = useData();
  let maxPrice = availableFleet
    ? availableFleet.reduce((acc, current) => Math.max(acc, current.price), 0)
    : 0;
  const [filteredFleet, setFilteredFleet] = useState<CarListingModal[] | []>(
    availableFleet ?? []
  );
  const [rangePrices, setRangePrices] = useState([0, maxPrice]);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (!pickupLocation) {
      navigate("/");
    }
  }, [pickupLocation]);

  useEffect(() => {
    if (
      selectedTypes.length === 0 ||
      getUniqueFleetClasses().length === selectedTypes.length
    ) {
      setFilteredFleet(availableFleet ?? []);
    } else {
      setFilteredFleet(
        availableFleet!.filter((item: CarListingModal) =>
          selectedTypes.includes(item?.fleet_class?.name ?? "")
        )
      );
    }
  }, [selectedTypes, availableFleet]);

  useEffect(() => {
    const filteredFleet = availableFleet?.filter(
      (item: any) =>
        item.price >= rangePrices[0] && item.price <= rangePrices[1]
    );

    setFilteredFleet(filteredFleet ?? []);
  }, [rangePrices, availableFleet]);

  const getUniqueFleetClasses = () => {
    return Array.from(
      new Set(availableFleet?.map((car) => car?.fleet_class?.name ?? ""))
    ).filter((item): item is string => item !== undefined && item !== "");
  };

  const renderCard = (car: any) => {
    return (
      <FleetCard
        key={car.id}
        data={car}
        simpleImg={true}
        onClick={() => {
          setSelectedCar(car);
          navigate("/listing-car-detail");
          return;
        }}
      />
    );
  };

  return (
    <div
      className={`nc-SectionGridFilterCard ${className}`}
      style={{ minHeight: "80vh" }}
      data-nc-id="SectionGridFilterCard"
    >
      <div className="flex lg:flex-row flex-col justify-between">
        <div className={`mb-4 lg:mb-16`}>
          <h2 className="text-2xl md:text-4xl font-bold">
            {"Available Fleet (" + availableFleet?.length + ")"}
          </h2>
        </div>

        <div className="mb-12 lg:mb-12">
          <TabFilters
            types={[...getUniqueFleetClasses()]}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
            rangePrices={rangePrices}
            setRangePrices={setRangePrices}
            maxPrice={maxPrice}
          />
        </div>
      </div>
      <div className="nc-SectionGridFeaturePlaces relative">
        <div
          className={`grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4`}
        >
          {filteredFleet?.map(
            (car: any) => car?.active === true && renderCard(car)
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionGridFilterCard;
